import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import {
  EXPERIMENTS_TRACK_EVENT_PDP_SHOW_SELLER_MODAL,
  experimentsTrackEvent,
} from '../../../../experiments/eventTracking'
import { useSellerModalContext } from '../../../../seller'
import { useProductPageContext } from '../../productPageContext'
import { useProductPrices } from '../hooks/useProductPrices'
import { useProductSellerBox } from '../hooks/useProductSellerBox'

type ProductBuyBoxSellerInfoProps = {
  /**
   * Temporary solution to close Seller Dialog while switching to another product.
   * Will move to {@link useSearchParamDependentOpenableControls} hook when it's stable.
   */
  key: string
}

export const ProductBuyBoxSellerInfo: FC<ProductBuyBoxSellerInfoProps> = () => {
  const { offerSeller, shouldRenderSellerBox } = useProductSellerBox()
  const { currentPrescriptionType, offerId, product } = useProductPageContext()
  const { showSellerModal } = useSellerModalContext()

  /**
   * We need to know if the offer is a partner's offer or an SAE offer.
   */
  const { isOfferMirakl } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product,
  })

  if (!offerSeller || !shouldRenderSellerBox || !isOfferMirakl) {
    return null
  }

  return (
    <div className="flex w-full flex-col pt-2">
      <div className="flex w-full justify-between">
        <span>
          <FormattedMessage id="message.soldAndShipped.partnerCrossSell" />
        </span>
        <span>
          <Link
            className="font-medium"
            color="inherit"
            data-clientside-hook={`open-seller-modal--${offerSeller.sellerId}`}
            data-qa-id="seller-name"
            onClick={() => {
              showSellerModal({
                productUpid: product.upid,
                sellerId: offerSeller.sellerId,
              })

              experimentsTrackEvent(
                EXPERIMENTS_TRACK_EVENT_PDP_SHOW_SELLER_MODAL,
              )
            }}
            slots={{ root: 'button' }}
            type="button"
          >
            <FormattedMessage id="general.more.information.short" />
          </Link>
        </span>
      </div>
      <div className="text-l font-medium">{offerSeller.displayName}</div>
    </div>
  )
}
